/** API Document ↔ UI document fields. */

export function documentFromApi(row) {
  if (!row) return null;
  return {
    id: row.id,
    ownerType: row.ownerType ?? '',
    ownerId: row.ownerId ?? null,
    docType: row.docType ?? '',
    fileName: row.fileName ?? '',
    mimeType: row.mimeType ?? '',
    sizeBytes: row.sizeBytes ?? null,
    storageKey: row.storageKey ?? '',
    status: row.status ?? 'pending',
    uploadedByStaffId: row.uploadedByStaffId ?? null,
    confirmedAt: row.confirmedAt ?? null,
    createdAt: row.createdAt ?? null,
    url: row.publicUrl ?? row.url ?? null,
  };
}
